import { LongText } from 'common/types/longText.types'

const handleLongText = ({ text = '', count = 20 }: LongText) => {
  if (text && text?.length > count) {
    return `${text.substring(0, count)}...`
  }
  return text
}

export default handleLongText
